var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"qi-login"},[_c('div',{staticClass:"qi-wallpaper"}),_c('div',{staticClass:"qi-form"},[_vm._m(0),_c('Login')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo login",attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("@/assets/qi-logo-branco.svg"),"alt":"Logo QI"}})])
}]

export { render, staticRenderFns }